import type Quill from 'quill'

/**
 * Quill's stock `link` format emits a bare `<a href>` — no `target`, no `rel`.
 * A link inserted via the toolbar button would open in the operator's current
 * tab and skip `rel="noopener"` protection, unlike the plain-text preview
 * linkifier (`linkifyPlainTextPreview`) which sets both. This extends the Link
 * blot so composer-created links carry them too. Registered globally (the right
 * default for every editor); `target`/`rel` are in DOMPurify's default
 * allow-list, so they survive sanitization into the HTML preview panes.
 *
 * Extracted from the module-load side effect so it can be unit-tested without
 * standing up a full editor — the test guards the `Quill.import('formats/link')`
 * shape, which a Quill version bump could otherwise silently change.
 */
export function registerNewTabLink(quill: typeof Quill): void {
  const LinkBlot = quill.import('formats/link') as {
    new (...args: unknown[]): object
    create(value: string): HTMLElement
  }
  class NewTabLinkBlot extends LinkBlot {
    static create(value: string): HTMLElement {
      const node = super.create(value)
      node.setAttribute('target', '_blank')
      node.setAttribute('rel', 'noopener noreferrer')
      return node
    }
  }
  quill.register('formats/link', NewTabLinkBlot, true)
}
